import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from './schemas';

export const audiencesSearchParams = new SearchParams(screenSchema);

export const audiencesLink = new Link('audiences', audiencesSearchParams);

export const audiencesDetailsLink = audiencesLink.child(':id');
